'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_ARTICLE_HEADER = {
  commonStyle: {
    maxWidth: 1232,
    color: "#333",
    fontSize: 34
  }
};

exports.DEFAULT_ARTICLE_HEADER = DEFAULT_ARTICLE_HEADER;
